var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-0.75 -0.75 24 24",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#ef1818",
    d: "M11.25 18.28125c-0.19415625 0 -0.3515625 -0.15740625 -0.3515625 -0.3515625s0.15740625 -0.3515625 0.3515625 -0.3515625",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ef1818",
    d: "M11.25 18.28125c0.19415625 0 0.3515625 -0.15740625 0.3515625 -0.3515625s-0.15740625 -0.3515625 -0.3515625 -0.3515625",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ef1818",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M11.25 14.765625v-7.03125",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ef1818",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.7696875 1.650009375c-0.13949999999999999 -0.28405312499999996 -0.355875 -0.5233125000000001 -0.62446875 -0.6906375C11.876625 0.7920478125 11.5665 0.70335375 11.25 0.70335375s-0.626625 0.0886940625 -0.89521875 0.256018125c-0.26859374999999996 0.167325 -0.48496875 0.406584375 -0.62446875 0.6906375L0.849384375 19.741875c-0.106903125 0.2175 -0.1566225 0.458625 -0.144463125 0.70059375 0.012159375 0.24206249999999999 0.08579625 0.47700000000000004 0.2139571875 0.68259375 0.1281590625 0.20568750000000002 0.3066215625 0.37528125 0.5185340625 0.49284374999999997 0.211903125 0.11756250000000001 0.450271875 0.17915625 0.692596875 0.17896874999999998H20.37c0.24234375 0.0001875 0.48065625000000006 -0.06140625 0.692625 -0.17896874999999998 0.211875 -0.11756250000000001 0.39037499999999997 -0.28715625 0.51853125 -0.49284374999999997 0.12815625 -0.20559375 0.20175 -0.44053125 0.21393749999999997 -0.68259375 0.012187499999999999 -0.24196875 -0.037593749999999995 -0.48309375 -0.14446874999999998 -0.70059375L12.7696875 1.650009375Z",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailed);
export default __webpack_public_path__ + "static/media/failed.151e86b1b373b72fc195ae27d077de4b.svg";
export { ForwardRef as ReactComponent };